// extracted by mini-css-extract-plugin
module.exports = {"piece":"styles-module--piece--3FVke"};